<div
    class="inner-content dark:rounded-2xl dark:border-2 dark:border-solid dark:border-contrast-yellow"
    ridangoAppTrapFocus
    role="dialog"
    aria-modal="true">
    <div class="flex-column flex h-full text-base">
        <div class="relative flex items-center py-5">
            <div class="w-10"></div>
            <h2 class="m-0 flex-1 text-center text-base font-bold" data-modal-title tabindex="-1">
                {{ 'CART_REDEEM_VALUE_CODE_TITTLE' | translate }}
            </h2>
            <!-- ORB has different text size because it uses a different font and this causes button shift -->
            <button
                class="right-4 flex items-center justify-center !leading-none text-grey-zambezy"
                [attr.aria-label]="'CLOSE' | translate"
                (click)="cancel()"
                mat-icon-button>
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="flex-align-center mx-4 flex justify-between">
            <ion-input
                class="bg-white_smoke w-full rounded-lg border border-solid px-2 dark:border dark:border-contrast-yellow dark:bg-contrast-black"
                [value]="valueCode"
                (ionInput)="valueCodeChange($event)">
            </ion-input>
        </div>
        <div class="m-4 mt-6">
            <button
                class="modal-confirm-button sr-app-light:text-white var-app-light:text-semibold h-14 w-full rounded-lg font-bold dark:bg-contrast-yellow dark:text-contrast-black"
                [disabled]="!valueCode?.length"
                [attr.aria-disabled]="!valueCode?.length"
                (click)="handleSaveClick()">
                {{ 'CART_APPLY_CODE' | translate }}
            </button>
        </div>
    </div>
</div>
